import { render, staticRenderFns } from "./colConfig.vue?vue&type=template&id=4e0a2c24&"
import script from "./colConfig.vue?vue&type=script&lang=js&"
export * from "./colConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports